import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f14dd14a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"modal\" tabindex=\"-1\" id=\"saveConfirmation\" data-v-f14dd14a><div class=\"modal-dialog\" data-v-f14dd14a><div class=\"modal-content\" data-v-f14dd14a><div class=\"modal-body\" data-v-f14dd14a><p data-v-f14dd14a>Handlingslistan har sparats på servern.</p></div><div class=\"modal-footer\" data-v-f14dd14a><button type=\"button\" class=\"btn btn-secondary\" data-bs-dismiss=\"modal\" data-v-f14dd14a> Stäng </button></div></div></div></div>", 1)
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Handlingslista", -1))
const _hoisted_3 = { class: "float-end" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex shopping-list-headers\" data-v-f14dd14a><div class=\"d-none d-md-block col-4\" data-v-f14dd14a>Vara</div><div class=\"d-none d-md-block col-2\" data-v-f14dd14a>Mängd</div><div class=\"d-none d-md-block col-5\" data-v-f14dd14a><span class=\"d-none d-md-block\" data-v-f14dd14a>Kommentar till butiken</span><span class=\"d-block d-md-none\" data-v-f14dd14a>Kommentar</span></div><div class=\"d-none d-md-block col-1\" data-v-f14dd14a></div><div class=\"d-block d-md-none col\" data-v-f14dd14a>Vara / mängd / kommentar</div></div>", 1)
const _hoisted_6 = {
  key: 0,
  class: "shopping-list-row"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shopping-list-col col-xs-12 text-center" }, " Listan är tom! Lägg till en rad med knappen nedan... ↘ ", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "shopping-list-col col-4" }
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = { class: "shopping-list-col col-2" }
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = { class: "shopping-list-col col-5" }
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = { class: "shopping-list-col col-1 text-center" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "row mt-2" }
const _hoisted_18 = { class: "col-sm-4 offset-sm-8" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "form-group mt-2" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "shopping-list-comment" }, "Generell kommentar till butiken:", -1))
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "row mt-2" }
const _hoisted_24 = { class: "col-sm-4 offset-sm-8" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "row mt-2" }
const _hoisted_27 = { class: "col-sm-4 offset-sm-8" }
const _hoisted_28 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back())),
        class: "btn btn-link"
      }, " ← Tillbaka "),
      _hoisted_2,
      (_ctx.shoppingList)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                class: "btn btn-lg btn-link",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.addDefaultItems()), ["prevent"]))
              }, [
                _createVNode(_component_fa_icon, { icon: "list-alt" })
              ])
            ]),
            _createElementVNode("h1", null, _toDisplayString(_ctx.shoppingList.name), 1),
            _createElementVNode("form", {
              onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.save()), ["prevent"])),
              class: "shopping-list-form"
            }, [
              _createElementVNode("fieldset", {
                class: "w-100",
                disabled: _ctx.shoppingList.isClosed
              }, [
                _hoisted_5,
                (_ctx.shoppingList.rows.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shoppingList.rows, (row, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: row.id,
                    class: "d-flex shopping-list-row"
                  }, [
                    _createElementVNode("div", _hoisted_9, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": ($event: any) => ((row.text) = $event),
                        placeholder: "Vara..."
                      }, null, 8, _hoisted_10), [
                        [_vModelText, row.text]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": ($event: any) => ((row.amount) = $event),
                        placeholder: "Mängd..."
                      }, null, 8, _hoisted_12), [
                        [_vModelText, row.amount]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": ($event: any) => ((row.comment) = $event),
                        placeholder: "Kommentar..."
                      }, null, 8, _hoisted_14), [
                        [_vModelText, row.comment]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("button", {
                        role: "button",
                        class: "btn btn-light",
                        onClick: _withModifiers(($event: any) => (_ctx.removeRow(idx)), ["prevent"])
                      }, [
                        _createVNode(_component_fa_icon, { icon: "trash-alt" })
                      ], 8, _hoisted_16)
                    ])
                  ]))
                }), 128))
              ], 8, _hoisted_4),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.shoppingList?.addRow()), ["prevent"])),
                    disabled: _ctx.shoppingList.isClosed,
                    class: "btn btn-primary d-block w-100"
                  }, " Ny rad ", 8, _hoisted_19)
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _withDirectives(_createElementVNode("textarea", {
                  class: "form-control",
                  id: "shopping-list-comment",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.shoppingList.comment) = $event)),
                  disabled: _ctx.shoppingList.isClosed,
                  rows: "3"
                }, null, 8, _hoisted_22), [
                  [_vModelText, _ctx.shoppingList.comment]
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("button", {
                    type: "submit",
                    disabled: _ctx.shoppingList.isClosed,
                    class: "btn btn-success d-block w-100"
                  }, " Spara ", 8, _hoisted_25)
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.saveAndSubmit()), ["prevent"])),
                    disabled: _ctx.shoppingList.isClosed,
                    class: "btn btn-danger d-block w-100"
                  }, " Skicka in ", 8, _hoisted_28)
                ])
              ])
            ], 32)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 64))
}